export default __webpack_public_path__ + "static/media/pink2.7deddd1f.jpg";